<template>
  <app-content class="data-history">
    <b-container fluid>
      <div class="p-3 data-history__border">
        <b-row
          class="no-internal-print mx-3"
          align-h="end"
        >
          <excel-export-button
            class="mr-2"
            @click="$event.wait(exportExcel())"
          />
          <b-button
            variant="outline-primary"
            :disabled="loading"
            @click="print"
          >
            {{ $t('buttons.print') }}
          </b-button>
        </b-row>
        <b-row
          v-if="loading"
          class="mt-4"
          align-self="center"
        >
          <b-col>
            <s-loader size="lg"/>
          </b-col>
        </b-row>
        <b-row
          v-else-if="chartData.length"
          class="data-history__chart"
        >
          <span class="data-history__title">
            {{ $t('reports.data-history.graph-title') }}
          </span>
          <default-chart
            class="m-2"
            x-data-manager="dateTime"
            legend-icon="rect"
            chart-id="data-history"
            :chartData="chartData"
            :loading="loadingChart"
            :remove-outlier.sync="removeChartOutlier"
            :enable-multi-axis.sync="enableChartMultiAxis"
            @toggle-outlier="getVisualization(true)"
            @toggle-multi-axis="getVisualization(true)"
          />
        </b-row>
        <b-row
          v-else
          class="w-100"
          align-h="center">
          <s-empty-list/>
        </b-row>
      </div>
      <b-row
        class="mt-5 no-internal-print"
        align-h="end">
        <b-col lg="2">
          <b-button
            block
            @click="closeTab"
            variant="primary"
          >
            {{ $t('actions.close') }}
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </app-content>
</template>

<script>

import DefaultChart from '@/components/charts/DefaultChart';
import ExcelExportButton from '@/components/buttons/ExcelExportButton';
import dataHistoryService from '@/domain/services/generalPanel/reports/dataHistory';
import print from '@/services/print';
import loadingMixin from '@/services/loadingMixin';
import defaultChartMixin from '@/domain/mixins/defaultChartMixin';

export default {
  props: {
    reportId: {
      type: String,
      required: true,
    },
  },
  components: {
    DefaultChart,
    ExcelExportButton,
  },
  mixins: [
    loadingMixin,
    defaultChartMixin,
  ],
  data: () => ({
    chartData: [],
    loadingExcel: false,
  }),
  created() {
    this.getVisualization();
  },
  methods: {
    print,
    exportExcel() {
      return dataHistoryService
        .exportExcel(this.reportId);
    },
    getVisualization(loadingChart) {
      const { reportId } = this.$route.params;
      if (!loadingChart) {
        this.startLoading();
      }
      this.loadingChart = loadingChart;
      dataHistoryService.getVisualization(reportId, this.chartFilters)
        .then((data) => {
          if (!loadingChart) {
            this.$pushAlert({ code: 'MS011' });
          }
          this.chartData = data.map(item => ({
            ...item,
            name: this.buildSeriesName(item),
          }));
        })
        .finally(() => {
          this.endLoading();
          this.loadingChart = false;
        });
    },
    buildSeriesName({
      installationName,
      assetName,
      moduleName,
      name,
      id,
    }) {
      const visible = `${installationName} - ${assetName} - ${moduleName} - ${name}`;
      const invisibleId = id.replace(/./g, c => String.fromCodePoint(c.charCodeAt(0) + 0xE0000));
      return `${visible}${invisibleId}`;
    },
    closeTab() {
      this.$confirmMessage({ code: 'MC022' })
        .accepted(() => window.close());
    },
  },
};
</script>

<style lang="sass" scoped>
  .data-history
    &__title
      font-weight: bold
      margin-left: 30px
      font-size: 1.1rem
    &__border
      border: 2px solid #bdbdbd52
      border-radius: 5px
    &__chart
      margin-top: 20px
      @media print
        margin-top: 0
    ::v-deep
      .line-chart__legend
        page-break-inside: auto
</style>
